// Keep one ID until an attempt is acknowledged. Retrying the same payload after
// a lost response must not append another human-handoff message.
export const prepareOpsyChatRequest = (pending, body) => {
  const signature = JSON.stringify(body);
  if (pending?.signature === signature) return pending;
  return { signature, body: { ...body, request_id: crypto.randomUUID() } };
};
